// react
import React from "react";

// components
import { Spacer } from "../components/Spacer";

const PrivacyPolicyPage = () => {
	return (
		<div style={{ padding: 16 }}>
			<p style={{ fontSize: 24, fontWeight: 800 }}>개인정보 처리방침</p>
			<Spacer distance={32} />

			<p>
				데브피즈는 정보주체의 자유와 권리 보호를 위해 「개인정보
				보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를
				처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」
				제30조에 따라 정보주체에게 개인정보의 처리와 보호에 관한 절차 및
				기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수
				있도록 하기 위하여 다음과 같이 개인정보 처리방침을
				수립・공개합니다.
			</p>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				1. 개인정보의 처리 목적
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 다음의 목적을 위하여 개인정보를 처리합니다.
					처리하고 있는 개인정보는 다음의 목적 이외의 용도로는
					이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보
					보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를
					이행할 예정입니다.
				</p>
			</div>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 32 }}>
				<p>1) 회원가입 및 관리</p>
				<p style={{ paddingLeft: 16 }}>
					회원가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증,
					회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지,
					고충처리 목적으로 개인정보를 처리합니다.
				</p>
				<p>2) 민원사무 처리</p>
				<p style={{ paddingLeft: 16 }}>
					민원인의 신원 확인, 민원사항 확인, 사실조사를 위한
					연락·통지, 처리결과 통보 목적으로 개인정보를 처리합니다.
				</p>
				<p>3) 재화 또는 서비스 제공</p>
				<p style={{ paddingLeft: 16 }}>
					서비스 제공, 콘텐츠 제공, 맞춤서비스 제공, 계약서·청구서
					발송, 본인인증, 요금결제·정산을 목적으로 개인정보를
					처리합니다.
				</p>
				<p>4) 마케팅 및 광고 활용</p>
				<p style={{ paddingLeft: 16 }}>
					신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성
					정보 제공 및 참여기회 제공 , 인구통계학적 특성에 따른 서비스
					제공 및 광고 게재 , 서비스의 유효성 확인, 접속빈도 파악 또는
					회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를
					처리합니다.
				</p>
				<p>5) 서비스 개선</p>
				<p style={{ paddingLeft: 16 }}>
					이상행위 탐지 및 서비스 개선을 위한 분석, 이용자의 정보이용
					기록을 통한 맞춤형 콘텐츠 및 서비스 제공을 목적으로
					개인정보를 처리합니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				2. 개인정보의 처리 및 보유 기간
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 법령에 따른 개인정보 보유·이용기간 또는
					정보주체로부터 개인정보를 수집 시에 동의받은 개인정보
					보유·이용기간 내에서 개인정보를 처리·보유합니다.
				</p>
				<p>
					2. 원칙적으로 개인정보의 수집·이용 목적이 달성되면 지체 없이
					파기합니다. 단, 관련 법령의 규정 또는 회사 내부 방침에
					의하여 보존할 필요가 있는 경우 아래에서 정한 기간 동안
					개인정보를 보유합니다.
				</p>
				<p>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
				<p>
					＜회원가입 및 관리＞ 와 관련한 개인정보는 수집.이용에 관한
					동의일로부터＜5년＞까지 위 이용목적을 위하여
					보유.이용됩니다.
				</p>
				<p>보유근거 : 관련법령</p>
				<p>관련법령 :</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>1) 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년</p>
				<p>2) 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년</p>
				<p>3) 대금결제 및 재화 등의 공급에 관한 기록 : 5년</p>
				<p>4) 계약 또는 청약철회 등에 관한 기록 : 5년</p>
				<p>5) 표시/광고에 관한 기록 : 6개월</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				3. 처리하는 개인정보의 항목
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>1. 데브피즈는 다음의 개인정보 항목을 처리하고 있습니다.</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>
					1) 사용자의 온라인식별자(광고ID, UUID 등), 단말기
					정보(제조사, OS종류, 버전), 닉네임, 이메일주소, 비밀번호,
					서비스 이용기록, 행동 기록, 접속 로그를 사용자가 입력 장치에
					입력 후 데브피즈는 서버에 전송함에 따라 수집합니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				4. 개인정보의 제3자 제공에 관한 사항
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 정보주체의 개인정보를 개인정보의 처리목적에서
					명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의
					특별한 규정 등에 해당하는 경우에만 개인정보를 제3자에게
					제공하고 그 이외에는 정보주체의 개인정보를 제3자에게
					제공하지 않습니다.
				</p>
				<p>
					2. 또한, 데브피즈는 원활한 서비스 제공을 위해 다음의 경우
					정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				5. 개인정보 처리업무의 위탁에 관한 사항
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 원활한 개인정보 업무처리를 위하여 다음과 같이
					개인정보 처리업무를 위탁하고 있습니다.
				</p>
				<p>
					2. 데브피즈는 위탁계약 체결 시 「개인정보 보호법」 제26조에
					따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적
					보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등
					책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가
					개인정보를 안전하게 처리하는지를 감독하고 있습니다.
				</p>
				<p>
					3. 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본
					개인정보 처리방침을 통하여 공개하도록 하겠습니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				6. 개인정보의 파기 절차 및 방법에 관한 사항
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 개인정보 보유기간의 경과, 처리목적 달성 등
					개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를
					파기합니다.
				</p>
				<p>
					2. 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나
					처리목적이 달성되었음에도 불구하고 다른 법령에 따라
					개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를
					별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여
					보존합니다.
				</p>
				<p>3. 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>1) 파기절차</p>
				<p style={{ paddingLeft: 16 }}>
					데브피즈는 파기 사유가 발생한 개인정보를 선정하고,
					데브피즈는 개인정보 보호책임자의 승인을 받아 개인정보를
					파기합니다.
				</p>
				<p>2) 파기방법</p>
				<p style={{ paddingLeft: 16 }}>
					데브피즈는 전자적 파일 형태로 기록·저장된 개인정보는 기록을
					재생할 수 없도록 파기하며, 종이 문서에 기록·저장된
					개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				7. 정보주체의 및 법정대리인 권리·의무 및 행사방법
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 정보주체는 데브피즈에 대해 언제든지 개인정보
					열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
				</p>
				<p>
					2. 권리 행사는 데브피즈에 대해 「개인정보 보호법」 시행령
					제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을
					통하여 하실 수 있으며, 데브피즈는 이에 대해 지체없이
					조치하겠습니다.
				</p>
				<p>
					3. 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
					대리인을 통하여 하실 수도 있습니다. 이 경우 "개인정보 처리
					방법에 관한 고시(제2020-7호)" 별지 제11호 서식에 따른
					위임장을 제출하셔야 합니다.
				</p>
				<p>
					4. 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」
					제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될
					수 있습니다.
				</p>
				<p>
					5. 개인정보의 정정 및 삭제 요구는 다른 법령에서 그
					개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를
					요구할 수 없습니다.
				</p>
				<p>
					6. 데브피즈는 정보주체 권리에 따른 열람의 요구, 정정·삭제의
					요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나
					정당한 대리인인지를 확인합니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				8. 개인정보의 안전성 확보조치에 관한 사항
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 개인정보의 안전성 확보를 위해 다음과 같은
					조치를 취하고 있습니다.
				</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>
					1) 관리적 조치: 내부관리계획 수립·시행, 전담조직 운영,
					정기적 직원 교육
				</p>
				<p>
					2) 기술적 조치: 개인정보처리시스템 등의 접근권한 관리,
					접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및
					갱신
				</p>
				<p>3) 물리적 조치: 전산실, 자료보관실 등의 접근통제</p>
			</div>
			<div style={{ paddingLeft: 16 }}>
				<p>
					2. 데브피즈는 개인정보의 안전성을 확보하기 위하여 법령에서
					규정하고 있는 사항 이외에도 자체적으로 안전성 확보를 위한
					활동을 시행하고 있습니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				9. 개인정보 자동 수집 장치의 설치·운영 및 그 거부에 관한 사항
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 이용자에게 개별적인 맞춤서비스를 제공하기 위해
					이용 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를
					사용합니다.
				</p>
				<p>
					2. 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가
					이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며
					이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.
				</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>
					1) 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹
					사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부
					등을 파악하여 이용자에게 최적화된 정보 제공을 위해
					사용됩니다.
				</p>
				<p>
					2) 쿠키의 설치·운영 및 거부: 웹브라우저 상단의 도구 {">"}{" "}
					인터넷 옵션 {">"} 개인정보 메뉴의 옵션 설정을 통해 쿠키
					저장을 거부할 수 있습니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				10. 개인정보 보호책임자
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 데브피즈는 개인정보 처리에 관한 업무를 총괄해서 책임지고,
					개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을
					위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
				</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>개인정보 보호책임자</p>
				<p>담당자 : 문동현 / aququa.service@gmail.com</p>
			</div>
			<div style={{ paddingLeft: 16 }}>
				<p>
					2. 정보주체는 데브피즈의 서비스(또는 사업)을 이용하시면서
					발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에
					관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수
					있습니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				11. 개인정보 열람 청구
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의
					열람 청구를 아래의 부서에 할 수 있습니다. 데브피즈는
					정보주체의 개인정보 열람 청구가 신속하게 처리되도록
					노력하겠습니다.
				</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>개인정보 열람 청구 접수·처리 부서</p>
				<p>부서명: 개인정보 보호팀</p>
				<p>대표 연락처: aququa.service@gmail.com</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				12. 권익침해 구제 방법
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					1. 정보주체는 개인정보침해로 인한 구제를 받기 위하여
					개인정보분쟁조정위원회, 한국인터넷진흥원
					개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수
					있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는
					아래의 기관에 문의하시기 바랍니다.
				</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>
					1) 개인정보분쟁조정위원회: (국번없이) 1833-6972
					(www.kopico.go.kr)
				</p>
				<p>
					2) 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)
				</p>
				<p>3) 대검찰청: (국번없이) 1301 (www.spo.go.kr)</p>
				<p>4) 경찰청: (국번없이) 182 (ecrm.cyber.go.kr)</p>
			</div>
			<div style={{ paddingLeft: 16 }}>
				<p>
					2. 데브피즈는 정보주체의 개인정보자기결정권을 보장하고,
					개인정보침해로 인한 상담 및 피해 구제를 위해 노력하고
					있습니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				13. 개인정보 처리방침의 변경
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>1. 이 개인정보 처리방침은 2024.07.21 부터 적용됩니다.</p>
			</div>
			<Spacer distance={32} />
		</div>
	);
};

export default PrivacyPolicyPage;
